import {
    displayCategory,
    displayCurrentRole,
    displayText,
    getResumePath,
    getResumeUrl,
    parseEnquiryMore,
    type EnquiryRow,
} from "./enquiry-helpers";
import {
    ENQUIRY_COPY_FIELD_LABELS,
    ENQUIRY_COPY_FIELDS_BY_FORM_TYPE,
    ENQUIRY_COPYABLE_FORM_TYPES,
    type EnquiryCopyFieldKey,
    type EnquiryCopyFormType,
} from "./enquiry-settings";
import { resolveEnquiryFormType } from "./enquiry-form-type";

const resolveCopyFormType = (row: EnquiryRow): EnquiryCopyFormType | "" => {
    const formType = resolveEnquiryFormType(row);
    return (ENQUIRY_COPYABLE_FORM_TYPES as readonly string[]).includes(formType)
        ? (formType as EnquiryCopyFormType)
        : "";
};

export const isEnquiryCopyable = (row: EnquiryRow) => Boolean(resolveCopyFormType(row));

const getCopyFieldValue = (row: EnquiryRow, field: EnquiryCopyFieldKey) => {
    const more = parseEnquiryMore(row);

    switch (field) {
        case "name":
            return row.name;
        case "phone":
            return row.phoneno;
        case "email":
            return row.email;
        case "category":
            return displayCategory(row);
        case "address":
            return row.location;
        case "message":
            return row.message;
        case "role":
            return displayCurrentRole(row);
        case "experience":
            return more.experience;
        case "linkedin":
            return more.linkedin;
        case "resume": {
            const resumePath = getResumePath(row);
            return resumePath ? getResumeUrl(resumePath) : "";
        }
        default:
            return "";
    }
};

export const formatEnquiryCopyText = (row: EnquiryRow) => {
    const formType = resolveCopyFormType(row);
    if (!formType) return "";

    return ENQUIRY_COPY_FIELDS_BY_FORM_TYPE[formType]
        .map((field) => `${ENQUIRY_COPY_FIELD_LABELS[field]}: ${displayText(getCopyFieldValue(row, field))}`)
        .join("\n");
};

export const getEnquiryCopyTooltip = (row: EnquiryRow) => {
    const formType = resolveCopyFormType(row);
    if (!formType) return "Copy enquiry details";

    const labels = ENQUIRY_COPY_FIELDS_BY_FORM_TYPE[formType].map((field) =>
        ENQUIRY_COPY_FIELD_LABELS[field].toLowerCase()
    );
    return `Copy ${labels.join(", ")}`;
};

export const copyEnquiryDetails = async (row: EnquiryRow) => {
    await navigator.clipboard.writeText(formatEnquiryCopyText(row));
};
